/**
 * SPARQ — product page: variant selection + gallery thumbnails.
 * Reads variant data from an embedded JSON script tag (no extra fetch),
 * keeps the Add to Cart / Buy Now buttons' data-variant-id in sync, and
 * swaps the main gallery image on thumbnail click. Vanilla JS only.
 */
(function () {
  var root = document.querySelector('[data-product-root]');
  if (!root) return;

  var dataEl = root.querySelector('[data-product-json]');
  var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
  var optionSelects = root.querySelectorAll('[data-option-select]');
  var addBtn = root.querySelector('[data-add-to-cart]');
  var buyBtn = root.querySelector('[data-buy-now]');
  var priceNow = root.querySelector('[data-price-now]');
  var priceWas = root.querySelector('[data-price-was]');
  var availability = root.querySelector('[data-availability]');
  var mainImage = root.querySelector('[data-main-image]');

  function formatMoney(cents) {
    return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(cents) : '$' + (cents / 100).toFixed(2);
  }

  function findVariant() {
    var selected = Array.prototype.map.call(optionSelects, function (el) { return el.value; });
    return variants.filter(function (v) {
      return selected.every(function (val, i) { return v.options[i] === val; });
    })[0];
  }

  function updateForVariant(variant) {
    if (!variant) {
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
      if (buyBtn) buyBtn.disabled = true;
      if (availability) availability.textContent = 'This combination is unavailable';
      return;
    }

    [addBtn, buyBtn].forEach(function (btn) {
      if (btn) btn.setAttribute('data-variant-id', variant.id);
    });

    if (priceNow) priceNow.textContent = formatMoney(variant.price);
    if (priceWas) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceWas.textContent = formatMoney(variant.compare_at_price);
        priceWas.hidden = false;
      } else {
        priceWas.hidden = true;
      }
    }

    var available = variant.available;
    if (addBtn) { addBtn.disabled = !available; addBtn.textContent = available ? addBtn.getAttribute('data-label-add') : addBtn.getAttribute('data-label-sold-out'); }
    if (buyBtn) buyBtn.disabled = !available;
    if (availability) availability.textContent = available ? '' : 'Sold out';

    if (mainImage && variant.featured_image) {
      mainImage.src = variant.featured_image;
    }

    // Keep ?variant= in the address bar in sync (standard Shopify behaviour, no reload).
    // Apps such as Profit Pumper Bundles read the selected variant from it.
    if (window.history && history.replaceState && window.URL) {
      var url = new URL(window.location.href);
      if (url.searchParams.get('variant') !== String(variant.id)) {
        url.searchParams.set('variant', variant.id);
        history.replaceState(history.state, '', url.toString());
      }
    }
  }

  optionSelects.forEach(function (select) {
    select.addEventListener('change', function () {
      updateForVariant(findVariant());
    });
  });

  if (variants.length) updateForVariant(findVariant());

  /* ---------------- Gallery thumbnails ---------------- */
  var thumbs = root.querySelectorAll('[data-thumb]');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImage) mainImage.src = thumb.getAttribute('data-full-src');
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* ---------------- Quantity stepper ---------------- */
  root.querySelectorAll('[data-quantity-stepper]').forEach(function (stepper) {
    var input = stepper.querySelector('[data-quantity-input]');
    stepper.querySelectorAll('[data-quantity-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-quantity-step'), 10);
        var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = next;
      });
    });
  });
})();

/* ---------------- Profit Pumper Bundles → buy box quantity ----------------
   The bundle app's tier picker ("1 / 2 / 3 Pair") doesn't talk to this theme's
   custom Add to Cart, and it pre-selects a tier on load without firing an event.
   Each tier radio's value is its quantity (1, 2, 3). Copy the selected tier into
   the buy box quantity field whenever a tier is picked, and again in the capture
   phase of every Add to Cart / Buy Now click (just before assets/cart.js reads it). */
(function () {
  function syncTierQuantity() {
    var tier = document.querySelector('input.pumper_pair:checked');
    var input = document.querySelector('[data-buy-box] [data-quantity-input]');
    var qty = tier ? parseInt(tier.value, 10) : 0;
    if (input && qty > 0) input.value = qty;
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('input.pumper_pair')) syncTierQuantity();
  });
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-buy-box] [data-add-to-cart], [data-buy-box] [data-buy-now]')) syncTierQuantity();
  }, true);
})();

/* ---------------- Single scent selector → variant ----------------
   [data-scent-select] options carry real variant IDs (matched by SKU in
   sections/product-main.liquid). Picking one sets the hidden native option
   dropdowns to that variant's options and fires their change event, so the
   existing variant logic above updates price, availability, image and the
   Add to Cart / Buy Now variant ID. */
document.addEventListener('change', function (e) {
  var scent = e.target;
  if (!scent || !scent.matches || !scent.matches('[data-scent-select]')) return;
  var box = scent.closest('[data-buy-box]');
  var dataEl = box && box.querySelector('[data-product-json]');
  if (!dataEl) return;
  var variants = [];
  try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
  var variant = variants.filter(function (v) { return String(v.id) === String(scent.value); })[0];
  if (!variant) return;
  var selects = box.querySelectorAll('[data-option-select]');
  selects.forEach(function (select, i) { select.value = variant.options[i]; });
  if (selects.length) selects[0].dispatchEvent(new Event('change', { bubbles: true }));
});

/* ---------------- Scent photos: preload ----------------
   On pages with the scent selector, fetch every variant's photo in the background
   so switching scents swaps the main image instantly (no visible load delay). */
(function () {
  var box = document.querySelector('[data-buy-box]');
  if (!box || !box.querySelector('[data-scent-select]')) return;
  var dataEl = box.querySelector('[data-product-json]');
  if (!dataEl) return;
  var list = [];
  try { list = JSON.parse(dataEl.textContent); } catch (err) { return; }
  function preload() {
    list.forEach(function (v) { if (v.featured_image) { var img = new Image(); img.src = v.featured_image; } });
  }
  if (document.readyState === 'complete') preload(); else window.addEventListener('load', preload);
})();
